import { useState, useEffect, useCallback } from 'react';

export interface DownloadLinkInfo {
  url: string;
  version: string;
  size: string;
  updated: string;
}

export interface DownloadLinks {
  android: DownloadLinkInfo;
  ios: DownloadLinkInfo;
  harmonyos: DownloadLinkInfo;
  windows: DownloadLinkInfo;
}

const FALLBACK_LINKS: DownloadLinks = {
  android: { url: '#', version: 'v5.1.6', size: '38.5 MB', updated: '2026-08-28' },
  ios: { url: '#', version: 'v2.8.2', size: '42.3 MB', updated: '2026-08-25' },
  harmonyos: { url: '#', version: 'v2.6.8', size: '36.7 MB', updated: '2026-08-20' },
  windows: { url: '#', version: 'v1.1.6', size: '55.2 MB', updated: '2026-08-28' },
};

function resolveJsonUrl(): string {
  const base =
    typeof __BASE_PATH__ === 'string' && __BASE_PATH__ !== '/' && __BASE_PATH__ !== ''
      ? __BASE_PATH__.replace(/\/+$/, '')
      : '';
  return `${base}/download-links.json`;
}

export function useDownloadLinks() {
  const [links, setLinks] = useState<DownloadLinks>(FALLBACK_LINKS);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const load = useCallback(() => {
    setLoading(true);
    setError(null);

    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 3000);

    fetch(resolveJsonUrl(), { signal: controller.signal })
      .then((res) => {
        if (!res.ok) throw new Error('加载下载信息失败');
        return res.json();
      })
      .then((data: DownloadLinks) => {
        setLinks(data);
      })
      .catch(() => {
        setError('下载信息加载失败，已展示默认信息');
      })
      .finally(() => {
        clearTimeout(timeout);
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  return { links, loading, error, reload: load };
}